import React from 'react';
import { LeaderboardPeriod } from './LeaderboardTypes';
import { TabsContainer, Tab } from './LeaderboardStyles';

interface LeaderboardTabsProps {
  activeTab: LeaderboardPeriod;
  onTabChange: (tab: LeaderboardPeriod) => void;
}

const LeaderboardTabs: React.FC<LeaderboardTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  return (
    <TabsContainer>
      <Tab
        active={activeTab === 'last-month'}
        onClick={() => onTabChange('last-month')}
      >
        Best Last Month
      </Tab>
      <Tab
        active={activeTab === 'last-week'}
        onClick={() => onTabChange('last-week')}
      >
        Best Last Week
      </Tab>
      <Tab
        active={activeTab === 'yesterday'}
        onClick={() => onTabChange('yesterday')}
      >
        Best Yesterday
      </Tab>
    </TabsContainer>
  );
};

export default LeaderboardTabs;
